// React Basic and Bootstrap
import React, { Component } from "react";
import { Row, Col } from "reactstrap";

function HowItWorks() {
  const steps = [
    {
      title: "Apply To An Opportunity",
      desc: "Press the 'Apply Now' button and fill out the form to be considered for the opportunity.",
    },
    {
      title: "Client Reviews Applications",
      desc: "The organizer of the opportunity reviews the applications and selects creators to participate",
    },
    {
      title: "Creators Chosen!",
      desc: "If chosen, you will receive a notification via text, email, and genni"
    },
  ];

  return (
    <React.Fragment>
      <Row>
        {steps.map((feat, i) => {
          return (
            <Col md="4" xs="12" key={i} name="featurebox" className="">
              <div className="work-process p-3 rounded bg-white shadow card">
                <div
                  class="mt-2 madeGentle text-pink mb-2"
                  style={{
                    borderRadius: "100%",
                    
                  }}
                >
                  <h3>{i + 1}.</h3>
                </div>
                <h5 className="title madeGentle">{feat.title}</h5>
                <p className="text-muted para Archivo">{feat.desc}</p>
              </div>
            </Col>
          );
        })}
      </Row>
    </React.Fragment>
  );
}

export default HowItWorks;
